import { createAction } from 'redux-actions'

export const onZoomIn = createAction('ON_ZOOM_IN')
export const onZoomOut = createAction('ON_ZOOM_OUT')
export const onZoomValueChecked = createAction('ON_ZOOM_VALUE_CHECKED')
